"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _default = exports.default = _vue.default.component('input-prompt', {
  props: ['label', 'hideCancel', 'block'],
  data() {
    return {
      value: '',
      state: 'pre',
      waiting: false
    };
  },
  computed: {
    hasChildren() {
      return !!this.$slots.default;
    }
  },
  created() {
    if (!this.hasChildren) {
      this.prompt();
    }
  },
  methods: {
    prompt() {
      this.state = 'prompt';
      this.$nextTick(() => {
        this.$el.querySelector('input').focus();
      });
    },
    complete() {
      if (this.waiting) {
        return;
      }
      if (this.hasChildren) {
        this.state = 'pre';
      } else {
        this.waiting = true;
      }
      const doneWaiting = () => {
        this.waiting = false;
      };
      this.$emit('submit', this.value, doneWaiting);
    },
    cancel() {
      if (this.hasChildren) {
        this.state = 'pre';
      }
      this.$emit('cancel');
    }
  }
});
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
if(!window._app_exports["components"]["utils"]) window._app_exports["components"]["utils"] = {};
window._app_exports["components"]["utils"]["InputPrompt"]
window._app_exports.components.utils.InputPrompt = exports.default ? exports.default : exports;
